import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';

import { ISupervisor } from '../../model/supervisor.model';

@Injectable()
export class SupervisorService extends EntityService<ISupervisor> {
  constructor(protected configService: ConfigService) {
    super({
      baseEntityEndPoint: 'supervisor',
      pluralBaseEntityEndPoint: 'supervisores',
      urlBackend: configService.backendURL
    });
  }
}
